import React from 'react'
import Navbar from 'components/navbar'
import Jumbotron from 'components/jumbotron'
import Category from 'components/category'
import MainSpan from 'components/span_main'
import MainFitures from 'components/main_fitures'
import Testimonial from 'components/testimonial'
import TestimonialJson from 'json/testimonial'
import Foters from 'components/footer'
 
export default function Home() {
    return (
           <>
            <Navbar />
            <Jumbotron />
            <Category />
            <MainSpan />
            <MainFitures />
            <Testimonial sliders={TestimonialJson} />
            <Foters />
            </>
            )
        }
        
        
        
       
        
       